<template>
    <div>
        <table-title>新增租赁框架协议</table-title>
        <Form ref="formValidates" :model="formValidate" :label-width="135" inline :rules="ruleValidate">
            <FormItem label="参与人" prop="memberId">
                <dict-select :exclusion="[]" namespace="bizObjects" id="member" v-model="formValidate.memberId" />
            </FormItem>
            <FormItem label="标的物小类" prop="targetType">
                <target-type-cascader @onTargetType="onTargetType" v-model="formValidate.targetType" />
            </FormItem>
            <br />
            <FormItem label="是否默认框架协议" prop="defaultFlag">
                <dict-select :exclusion="[]" namespace="default" id="bitYesNo" v-model="formValidate.defaultFlag" />
            </FormItem>
            <FormItem label="计费模式类型" prop="billingModeType">
                <dict-select :exclusion="['1']" namespace="default" id="billingModeType" v-model="formValidate.billingModeType" />
            </FormItem>

            <br />
            <FormItem label="最大额度"  prop="maxAmount">
                <InputNumber v-model="formValidate.maxAmount" :min="1" :precision="0" style="width:200px"/>
            </FormItem>
            <FormItem label="有效期"  prop="validDate">
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择有效期范围" style="width: 200px" @on-change="onDateChange" transfer></DatePicker>
            </FormItem><br>
            <FormItem label="计费模式名称" prop="billingModeName">
                <Input v-model="formValidate.billingModeName" clearable placeholder="请输入计费模式名称" style="width: 200px" />
            </FormItem>
            <Button type="success" style="margin-left:10px" @click="onQueryModel">选择计费模式</Button><br>
            <FormItem label="租期" prop="rentTerm" v-if="rentTermShow">
                <InputNumber style="width:200px" :min="1" v-model="formValidate.rentTerm" placeholder="请输入" />
            </FormItem>
            <!-- <FormItem label="动态策略编号">
                <Input v-model="formValidate.strategyId" clearable placeholder="请输入动态策略编号" style="width: 200px" />
            </FormItem>-->
            <br>
        </Form>
        <div style="text-align:center">
            <Button type="primary" @click="submit">提交</Button>
            <Button type="warning" style="margin-left:10px" @click="$emit('onFinish')">返回</Button>
        </div>
        <query-model ref="queryModelRef" @onChild="onChild" />
    </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import payeeSelect from '@/components/select/payee-select.vue'
import targetTypeCascader from '@/components/select/targetType-cascader'
import dictSelect from '@/components/select/dict-select.vue'
import queryModel from './component/queryModel'

export default {
    props: ['paramsData'],
    components: { tableTitle, payeeSelect, targetTypeCascader, dictSelect, queryModel },
    data() {
        return {
            rentTermShow:false,
            formValidate: {
                defaultFlag: "",
                memberId: "",
                targetType: "",
                billingModeType: "",
                billingModelId: "",
                strategyId: "",
                billingModeName: "",
                rentTerm: '',
                maxAmount: '',
                validDate:''
            },
            ruleValidate: {
                memberId: [{ required: true, message: "请选择参与人", trigger: 'change' }],
                targetType: [{ required: true, message: "请选择标的物小类", trigger: 'change' }],
                defaultFlag: [{ required: true, message: "请选择默认框架协议", trigger: 'change' }],
                billingModeType: [{ required: true, message: "请选择计费模式类型", }],
                billingModeName: [{ required: true, message: "请输入计费模式名称", }],
                rentTerm: [{ required: true, message: "请输入租期" }],
                validDate: [{ required: true, message: "请选择有效期" }]
            }
        }
    },
    methods: {
        onTargetType(params) {
            this.formValidate.targetType = params
        },
        // 选择计费模式
        onQueryModel() {
            this.$refs['queryModelRef'].openModal()
        },
        // 选择计费模式后返回
        onChild(params) {
            console.log(params)
            this.formValidate.billingModelId = params.id
            this.formValidate.billingModeName = params.name
            if(params.modelId ==='01'|| params.modelId === '02' || params.modelId === '06'){
                this.rentTermShow = false;
                this.formValidate.rentTerm = "";
            }else{
                this.rentTermShow = true
            }

        },
        onDateChange(selection){
            this.formValidate.validDate = selection[0];
            this.formValidate.invalidDate = selection[1];
        },
        submit() {
            this.$refs['formValidates'].validate((valid) => {
                if (valid) {
                    delete this.formValidate.billingModeName
                    let data = {
                        url: 'CORE-CONTRACT/messageService/billingModelService/addFrameRentEntity',
                        body: { frameRentEntity: this.formValidate }
                    }

                    this.$Modal.confirm({
                        title: '确定要新增租赁框架协议吗？',
                        onOk: () => {
                            this.invoke(data).then(res => {
                                console.log(res)
                                if (!res) {
                                    this.$emit('onFinish')
                                }
                            })
                        },
                    });
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
</style>